import React from 'react';

export default function RemoveButton({ onClick }) {

  return (
    <div className="flex justify-end items-center ml-auto p-2 absolute top-0 right-0">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-5 w-5 cursor-pointer transform duration-500 hover:rotate-90 transition-all"
        fill="none"
        viewBox="0 0 24 24"
        stroke="#8990AD"
        onClick={onClick}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M6 18L18 6M6 6l12 12"
        />
      </svg>
    </div>
  );

}
